import { render, staticRenderFns } from "./ProfileStats.vue?vue&type=template&id=9c6d77a6&"
import script from "./ProfileStats.vue?vue&type=script&lang=js&"
export * from "./ProfileStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports